import React, { useEffect, useState } from 'react';
import emailjs from 'emailjs-com';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true); // Show loading animation

    emailjs.send('service_1piskws', 'template_p4n7msi', 
      {
        from_name: `Name: ${formData.name} Email: ${formData.email}`,
        to_name: 'Anastasis',
        message: formData.message},
         'Cfi_sATCUmDao6M-M')
      .then((result) => {
        setIsLoading(false);
        setIsSuccess(true);
        setErrorMessage('');
        setFormData({ name: '', email: '', message: '' }); // Clear the form
      }, (error) => {
        setIsLoading(false);
        setIsSuccess(false);
        setErrorMessage('Failed to send email. Please try again.');
      });
  };

  return (
    <div className="flex items-center justify-center min-h-screen" style={{ backgroundColor: '#FAF4F0' }}>
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-bold mb-6 text-gray-800 text-center">Contact Us</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full mt-2 p-2 border border-gray-300 rounded-lg focus:ring focus:ring-indigo-200"
              placeholder="Your Name"
            />
          </div>
          <div>
            <label className="block text-gray-700">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full mt-2 p-2 border border-gray-300 rounded-lg focus:ring focus:ring-indigo-200"
              placeholder="Your Email"
            />
          </div>
          <div>
            <label className="block text-gray-700">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              className="w-full mt-2 p-2 border border-gray-300 rounded-lg focus:ring focus:ring-indigo-200"
              placeholder="Your Message"
            ></textarea>
          </div>
          <button
            type="submit"
            className={`w-full text-white py-2 rounded-lg transition duration-300 ${
              isLoading ? 'bg-gray-500 cursor-not-allowed' : isSuccess ? 'bg-green-600' : 'bg-indigo-600 hover:bg-indigo-500'
            }`}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="4" fill="none"></circle>
                  <path d="M4 12a8 8 0 018-8v8z" fill="white"></path>
                </svg>
                Sending...
              </div>
            ) : isSuccess ? 'Email Sent!' : 'Submit'}
          </button>

          {isSuccess && (
            <p className="text-green-600 mt-4 text-center">Email sent successfully!</p>
          )}
          {errorMessage && (
            <p className="text-red-600 mt-4 text-center">{errorMessage}</p>
          )}
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
